<template src="./calendar.html"> </template>

<script>
import { get_calendar, get_clienti, get_utenti, get_tasks, save_task, del_calendar, del_task } from "@/api/api.calendar.js";
import dialogCalendario from "@/components/dialog/calendar/CalendarItem";
import DialogTask from "@/components/dialog/calendar/TaskItem";
import DialogEsporta from "@/components/dialog/calendar/Esporta";
import DialogRiprogramma from "@/components/dialog/calendar/Riprogramma";
import ToolbarContent from "./ToolbarContent.vue";
import Holidays from "date-holidays";
import storage from "@/services/storage.js";

const MAX_EVENTI_VISIBILI = 3;

const COLORI_ORE = {
  default: 'var(--primary)',
  Ferie: '#FDD835',
  Permesso: '#FFA000',
  Mutua: '#E91E63',
  Trasferta: '#1976D2',
  Corso: '#512DA8',
  "Visita medica": '#00BCD4'
};

const COLORI_TASK = {
  Appuntamento: '#F9A825',
  Nota: '#009688',
  Attivita: '#8BC34A',
  Riunione: '#FF5722',
};

export default {
  components: { dialogCalendario, DialogEsporta, DialogTask, DialogRiprogramma, ToolbarContent },

  data: () => ({
    today: new Date().toISOString().substr(0, 10),
    todayReal: new Date().toISOString().substr(0, 10),
    anno: new Date().toISOString().substr(0, 4),

    events: [],
    tasks: [],
    eventoSel: {},
    taskSel: null,

    clienti: [],
    filtriUtenti: [],
    filtroUtenteSel: "",

    search: "",
    mostraCompletate: false,
    mostraPromemoria: true,
    mostraOre: true,
    mostraTask: true,

    // vista: month | week | day | agenda
    vista: 'month',

    dialogIns: false,
    dialogEsporta: false,
    dialogRiprogramma: false,
    dialogTask: false,

    drawer: false,
    drawerItem: null,
    drawerTipo: null, // 'ore' | 'task' | 'promemoria'

    fabOpen: false,

    MAX_EVENTI_VISIBILI,

    feste: [],

    rangeVisibile: null,
  }),

  computed: {
    role() { return storage.getRole(); },
    userName() { return storage.getUsername(); },

    tipoCalendario() {
      const map = { month: 'month', week: 'week', day: 'day', agenda: 'month' };
      return map[this.vista] || 'month';
    },

    // tutti gli eventi ore filtrati e con feste
    eventsConFeste() {
      if (!this.mostraOre) return [];
      let arr = [...this.feste, ...this.events];
      if (this.search) {
        const s = this.search.toLowerCase();
        arr = arr.filter(f => !f.festa && (
          (f.ragSoc || '').toLowerCase().includes(s) ||
          (f.descrizione || '').toLowerCase().includes(s)
        )).concat(this.feste);
      }
      return arr;
    },

    // task filtrate (senza quelle senza orario = promemoria)
    tasksFiltrate() {
      if (!this.mostraTask) return [];
      let arr = this.tasks;
      if (this.search) {
        const s = this.search.toLowerCase();
        arr = arr.filter(f =>
          (f.ragSoc || '').toLowerCase().includes(s) ||
          (f.descrizione || '').toLowerCase().includes(s)
        );
      }
      // task con orario o tutto il giorno = mostrate nel calendario
      return arr.filter(t => !t.festa && (t.giornoIntero || t.oraInizio));
    },

    // promemoria = task senza orario e non tutto il giorno
    promemoriaMappa() {
      const map = {};
      this.tasks.filter(t => !t.festa && !t.giornoIntero && !t.oraInizio).forEach(t => {
        (map[t.data] = map[t.data] || []).push(t);
      });
      return map;
    },

    giorniMese() {
      const d = new Date(this.today + 'T00:00:00');
      const anno = d.getFullYear();
      const mese = d.getMonth();
      const giorni = [];
      const data = new Date(anno, mese, 1);
      while (data.getMonth() === mese) {
        giorni.push(data.toISOString().substr(0, 10));
        data.setDate(data.getDate() + 1);
      }
      return giorni;
    },

    drawerHeaderColor() {
      if (!this.drawerItem) return 'grey darken-2';
      if (this.drawerTipo === 'promemoria') return 'blue-grey darken-2';
      if (this.drawerTipo === 'ore') {
        return this.coloreOreHex(this.drawerItem.tipoOre);
      }
      return this.coloreTaskHex(this.drawerItem.tipologia);
    },

    drawerTitolo() {
      if (!this.drawerItem) return '';
      if (this.drawerTipo === 'promemoria') return `${this.drawerItem.lista.length} promemoria`;
      if (this.drawerTipo === 'ore') return this.drawerItem.ragSoc || this.drawerItem.tipoOre;
      return this.drawerItem.descrizione || this.drawerItem.ragSoc || 'Attività';
    },

    /**
     * Converte events + tasks nel formato nativo di Vuetify 2 v-calendar.
     * Usato SOLO per le viste week e day (in month usiamo lo slot day custom).
     */
    eventiVuetify() {
      if (this.tipoCalendario === 'month') return [];

      let risultato = [];

      // ── Feste ──
      this.feste.forEach(f => {
        risultato.push({
          name: f.ragSoc,
          start: f.data,
          end: f.data,
          color: '#388E3C',
          timed: false,
          _tipo: 'ore',
          _raw: f,
        });
      });

      // ── Ore ──
      this.events.forEach(ev => {
        const bg = COLORI_ORE[ev.tipoOre] || COLORI_ORE.default;
        risultato.push({
          name: `${ev.tipoOre}${ev.ragSoc ? ' · ' + ev.ragSoc : ''} ${ev.ore}h`,
          start: ev.data,
          end: ev.data,
          color: bg,
          timed: false,
          _tipo: 'ore',
          _raw: ev,
        });
      });

      // ── Task con orario ──
      this.tasksFiltrate.forEach(task => {
        const bg = COLORI_TASK[task.tipologia] || '#607D8B';
        const hasTime = !task.giornoIntero && task.oraInizio;
        const start = hasTime ? `${task.data} ${task.oraInizio}` : task.data;
        const end = hasTime && task.oraFine ? `${task.data} ${task.oraFine}` : start;
        risultato.push({
          name: task.descrizione || task.ragSoc || 'Attività',
          start,
          end,
          color: bg,
          timed: !!hasTime,
          _tipo: 'task',
          _raw: task,
        });
      });

      return risultato;
    },
  },

  methods: {
    // ─── Caricamento ───────────────────────────────────────────────
    async refresh() {
      await Promise.all([this.caricaDati(), this.caricaAttivita()]);
    },

    async caricaUtenti() {
      this.filtroUtenteSel = this.userName;
      if (this.role !== 'admin') return;
      const res = await get_utenti();
      this.filtriUtenti = res.data;
    },

    async caricaClienti() {
      const res = await get_clienti();
      this.clienti = res.data;
    },

    async caricaDati() {
      const par = this.today + "/" + (this.filtroUtenteSel || "");
      try {
        const res = await get_calendar(par);
        this.events = res.data.map(e => ({ ...e, data: e.data.substring(0, 10) }));
      } catch (e) {
        console.error(e);
        this.$toast.alert(this.$functions.getErrorMsg(e));
      }
    },

    async caricaAttivita() {
      let par = this.today + "/" + (this.filtroUtenteSel || "");
      if (this.mostraCompletate) par += "/1";
      try {
        const res = await get_tasks(par);
        this.tasks = res.data.map(t => ({ ...t, data: t.data.substring(0, 10) }));
      } catch (e) {
        console.error(e);
      }
    },

    // ─── Mappe eventi per giorno ───────────────────────────────────
    eventiGiorno(date) {
      return this.eventsConFeste.filter(e => e.data === date);
    },

    taskGiorno(date) {
      return this.tasksFiltrate.filter(t => t.data === date);
    },

    totaleEventiGiorno(date) {
      return this.eventiGiorno(date).length + this.taskGiorno(date).length;
    },

    totaleEventiGiornoConPromemoria(date) {
      return this.totaleEventiGiorno(date) + (this.promemoriaMappa[date] || []).length;
    },

    // ─── Stili ─────────────────────────────────────────────────────
    styleEventoOre(ev) {
      if (ev.festa) return { backgroundColor: '#388E3C', color: '#fff', fontWeight: 'bold' };
      const bg = COLORI_ORE[ev.tipoOre] || COLORI_ORE.default;
      const isDark = !['Ferie', 'Permesso'].includes(ev.tipoOre);
      return { backgroundColor: bg, color: isDark ? '#fff' : '#000', fontWeight: '600' };
    },

    styleTask(task) {
      const bg = COLORI_TASK[task.tipologia] || '#607D8B';
      return { backgroundColor: bg, color: '#000' };
    },

    coloreOreHex(tipo) {
      return COLORI_ORE[tipo] || '#424242';
    },

    coloreTaskHex(tipo) {
      return COLORI_TASK[tipo] || '#607D8B';
    },

    // ─── Tooltip ───────────────────────────────────────────────────
    tooltipOre(ev) {
      if (ev.festa) return ev.ragSoc;
      return `${ev.tipoOre} - ${ev.destinazione || ''}: ${ev.ore}h${ev.minuti > 0 ? ev.minuti + 'm' : ''}`;
    },

    tooltipTask(task) {
      return `${task.ragSoc || ''}<br>${task.descrizione || 'Nessun titolo'}<br>${task.giornoIntero ? 'Tutto il giorno' : (task.oraInizio + '-' + task.oraFine)}`;
    },

    tipoTaskLabel(tipo) {
      const map = { Appuntamento: 'Appuntamento', Nota: 'Nota', Attivita: 'Attività', Riunione: 'Riunione' };
      return map[tipo] || tipo || '';
    },

    // ─── Drawer ────────────────────────────────────────────────────
    apriDrawer(item, tipo) {
      this.drawerItem = item;
      this.drawerTipo = tipo;
      this.drawer = true;
    },

    apriDrawerPromemoria(date) {
      this.drawerItem = {
        data: date,
        lista: this.promemoriaMappa[date] || [],
      };
      this.drawerTipo = 'promemoria';
      this.drawer = true;
    },

    chiudiDrawer() {
      this.drawer = false;
      this.drawerItem = null;
      this.drawerTipo = null;
    },

    modificaDrawerItem() {
      if (!this.drawerItem) return;
      this.eventoSel = { ...this.drawerItem };
      this.chiudiDrawer();
      if (this.drawerTipo === 'ore' || this.eventoSel.tipoOre) {
        this.dialogIns = true;
      } else {
        this.dialogTask = true;
      }
    },

    duplicaDrawerItem() {
      if (!this.drawerItem) return;
      // Copia come nuovo (prog = -1)
      this.eventoSel = { ...this.drawerItem, prog: -1, data: this.today };
      this.chiudiDrawer();
      if (this.drawerTipo === 'ore' || this.eventoSel.tipoOre) {
        this.dialogIns = true;
      } else {
        this.dialogTask = true;
      }
    },

    async eliminaDrawerItem() {
      if (!this.drawerItem) return;
      const confirm = await this.$confirm.open('Elimina', 'Vuoi eliminare questo elemento?');
      if (!confirm) return;
      try {
        const isOre = this.drawerTipo === 'ore';
        if (isOre) {
          await del_calendar(this.drawerItem.data + '/' + this.drawerItem.prog);
          await this.caricaDati();
        } else {
          await del_task(this.drawerItem.data + '/' + this.drawerItem.prog);
          await this.caricaAttivita();
        }
        this.chiudiDrawer();
      } catch (e) {
        this.$toast.error(this.$functions.getErrorMsg(e));
      }
    },

    async completaDrawerTask(stato) {
      if (!this.drawerItem) return;
      this.drawerItem.completato = stato;
      try {
        await save_task(this.drawerItem, '');
        await this.caricaAttivita();
      } catch (e) {
        this.drawerItem.completato = !stato;
        this.$toast.error("Errore durante l'aggiornamento");
      }
    },

    riprogrammaDrawerTask() {
      this.taskSel = this.drawerItem;
      this.chiudiDrawer();
      this.dialogRiprogramma = true;
    },

    // ─── Metodi eventi Vuetify (week/day) ─────────────────────────
    getEventColor(event) {
      return event.color;
    },

    clickEventoVuetify({ event, nativeEvent }) {
      nativeEvent && nativeEvent.stopPropagation();
      if (!event || !event._raw) return;
      const tipo = event._tipo || 'task';
      this.apriDrawer(event._raw, tipo);
    },

    handleDayClick({ date }) {
      // click singolo: aggiorna today senza aprire dialog
      this.today = date;
    },

    // ─── Navigazione ───────────────────────────────────────────────
    navigaPrev() {
      this.$refs.calendar && this.$refs.calendar.prev();
    },

    navigaNext() {
      this.$refs.calendar && this.$refs.calendar.next();
    },

    tornaOggi() {
      this.today = this.todayReal;
    },

    vaiAlGiorno(date) {
      this.today = date;
      this.vista = 'day';
    },

    // ─── Agenda helpers ────────────────────────────────────────────
    formatGiornoAgenda(date) {
      return new Date(date + 'T00:00:00').toLocaleDateString('it-IT', {
        weekday: 'long', day: 'numeric', month: 'long',
      });
    },

    isFestivo(date) {
      return this.feste.some(f => f.data === date);
    },

    nomeFestivo(date) {
      return (this.feste.find(f => f.data === date) || {}).ragSoc || '';
    },

    // ─── Dialog ────────────────────────────────────────────────────
    apriDialog(event) {
      if (event) {
        if (event.festa) return;
        this.eventoSel = event;
      } else {
        if (!this.filtroUtenteSel) {
          this.$toast.info('Utente non selezionato');
          return;
        }
        this.eventoSel = { data: this.today, prog: -1, utente: this.filtroUtenteSel };
      }
      this.dialogIns = true;
    },

    apriDialogTask(event) {
      if (event) {
        if (event.festa) return;
        this.eventoSel = event;
      } else {
        if (!this.filtroUtenteSel) {
          this.$toast.info('Utente non selezionato');
          return;
        }
        this.eventoSel = { data: this.today, prog: -1, utenteCreazione: this.filtroUtenteSel };
      }
      this.dialogTask = true;
    },

    chiudiDialog(aggiorna) {
      this.dialogIns = false;
      this.dialogTask = false;
      if (aggiorna) this.refresh();
    },

    esportaExcel() { this.dialogEsporta = true; },
    chiudiEsporta() { this.dialogEsporta = false; },

    chiudiRiprogramma(aggiorna) {
      this.dialogRiprogramma = false;
      if (aggiorna) this.refresh();
    },

    // ─── Tastiera ──────────────────────────────────────────────────
    handleKeyPress(e) {
      if (e.key === 'Escape') {
        if (this.drawer) { this.chiudiDrawer(); return; }
      }
      if (e.key.toLowerCase() === 't') {
        const tag = document.activeElement.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA' || document.activeElement.isContentEditable) return;
        if (this.dialogTask || this.dialogEsporta || this.dialogIns) return;
        this.today = this.todayReal;
      }
    },

    handleDayDblClick({ date }) {
      this.today = date;
      this.apriDialog();
    },

    // ─── URL params ────────────────────────────────────────────────
    verificaParametri() {
      const params = new URLSearchParams(window.location.search);
      const data = params.get('data');
      const prog = params.get('prog');
      const tool = params.get('tool');
      if (tool === 'tasks') this.vista = 'agenda';
      if (data && prog) {
        const d = this.$functions.formatDate(data);
        const task = this.tasks.find(t => t.data === d && t.prog === Number(prog));
        if (task) {
          this.eventoSel = { data: d, prog: Number(prog), utenteCreazione: this.filtroUtenteSel };
          this.dialogTask = true;
        }
      }
    },

    caricaFestivita() {
      let hd = new Holidays("IT");
      this.feste = hd.getHolidays(this.anno)
        .filter(f => f.type.toLowerCase() === "public")
        .map(ff => ({
          data: ff.date.toString().substring(0, 10),
          ragSoc: ff.name,
          festa: true,
          tipoOre: 'Festivo',
        }));
    },

    onCalendarChange({ start, end }) {
      this.rangeVisibile = {
        start: start.date,
        end: end.date
      };
    },

    getTotaleOre() {
      let eventiFiltrati = this.eventsConFeste;
      if (this.search) {
        let s = this.search.toLowerCase();
        eventiFiltrati = this.eventsConFeste.filter(ev =>
          (ev.ragSoc || '').toLowerCase().includes(s) ||
          (ev.descrizione || '').toLowerCase().includes(s)
        );
      }

      let eventiVisibiliCalendario = [];
      if (this.rangeVisibile) {
        const { start, end } = this.rangeVisibile;
        eventiVisibiliCalendario = eventiFiltrati.filter(ev =>
          ev.data >= start &&
          ev.data <= end
        );
      }

      return eventiVisibiliCalendario
        .filter(ev => ev.tipoOre === "Lavoro")
        .reduce((tot, ev) => {
          const ore = Number(ev.ore) || 0;
          const minuti = Number(ev.minuti) || 0;
          return tot + ore + minuti / 60;
        }, 0);
    },
  },

  async mounted() {
    window.addEventListener('keydown', this.handleKeyPress);
    this.caricaUtenti();
    this.caricaClienti();
    await this.refresh();
    this.verificaParametri();
    this.caricaFestivita();
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyPress);
  },

  watch: {
    today() {
      this.refresh();
      if (this.today.substring(0, 4) != this.anno.toString()) {
        this.anno = Number(this.today.substring(0, 4));
        this.caricaFestivita();
      }
    },
    filtroUtenteSel() { this.refresh(); },
    mostraCompletate() { this.caricaAttivita(); },
    vista(v) {
      this.$router.push({ query: { tool: v } }).catch(() => { });
    },
  },
};
</script>

<style scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 3px;
  width: 100%;
  font-size: 11px;
  padding: 2px 4px;
  cursor: pointer;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  gap: 2px;
}

.my-event--ore {
  padding: 3px 5px;
  border-left: 3px solid rgba(0, 0, 0, 0.2);
}

.my-event--task {
  border-left: 3px solid rgba(0, 0, 0, 0.15);
  opacity: 0.92;
}

/* Badge promemoria */
.promemoria-badge {
  display: flex;
  align-items: center;
  background-color: #546E7A;
  color: white;
  font-size: 10px;
  padding: 2px 5px;
  border-radius: 10px;
  cursor: pointer;
  margin-bottom: 3px;
  width: fit-content;
  max-width: 100%;
}

.vedi-tutti {
  font-size: 10px;
  color: var(--v-primary-base);
  cursor: pointer;
  padding: 1px 3px;
  font-weight: 600;
}

.vedi-tutti:hover {
  text-decoration: underline;
}

/* Agenda */
.agenda-container {
  border-radius: 5px;
  overflow: hidden;
}

.agenda-day {
  border-bottom: 1px solid #e0e0e0;
  min-height: 56px;
}

.agenda-day--today {
  background-color: #E3F2FD;
}

.agenda-day-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
  cursor: default;
}

.agenda-day-label {
  font-weight: 600;
  font-size: 13px;
  text-transform: capitalize;
}

.agenda-day-festivo {
  font-size: 11px;
  color: #388E3C;
  background: #E8F5E9;
  padding: 1px 6px;
  border-radius: 8px;
}

.agenda-empty {
  font-size: 12px;
  color: #9E9E9E;
  font-style: italic;
  padding: 2px 0;
}

.agenda-promemoria-badge {
  display: flex;
  align-items: center;
  background-color: #546E7A;
  color: white;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 10px;
  cursor: pointer;
  margin-bottom: 5px;
  width: fit-content;
}

.agenda-col-empty {
  color: #bdbdbd;
  font-size: 12px;
  padding: 4px;
}

/* Drawer */
.drawer-label {
  font-size: 11px;
  color: #757575;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.drawer-value {
  font-size: 14px;
  color: #212121;
  margin-bottom: 12px;
}

/* FAB mobile */
#pulsantiAzione {
  position: fixed;
  right: 1.2em;
  bottom: 1em;
  z-index: 100;
}

.gap-2 {
  gap: 8px;
}

/* Chip evento nelle viste week/day */
.cal-event-chip {
  width: 100%;
  height: 100%;
  padding: 2px 5px;
  font-size: 11px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 3px;
  cursor: pointer;
  color: #fff;
}

.cal-event-chip--ore {
  font-size: 12px;
  font-weight: 600;
  border-left: 3px solid rgba(0, 0, 0, 0.25);
}

.cal-event-chip__tipo {
  font-weight: 700;
}

.cal-event-chip__detail {
  opacity: 0.9;
}

/* Badge promemoria nell'header del giorno (week/day) */
.day-label-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding-bottom: 4px;
}

.promemoria-badge--header {
  padding: 1px 5px;
  font-size: 9px;
  border-radius: 8px;
}
</style>